// extracted by mini-css-extract-plugin
export default {"card":"i1-z","carouselContainer":"j1-z","carouselContent":"k1-z"};